import { Task } from "@quales/data-access/gql-server";
import dayjs from "dayjs";
import React from "react";
import { useTranslations } from "next-intl";
import { useTheme } from "@quales/utils/theme";
import {
  WcAvatar,
  WcCard,
  WcCardContent,
  WcChip,
  WcIcon,
  WcStack,
  WcTypography,
} from "@bpipartners/webui";
import { PiCalendarDots } from "react-icons/pi";

interface TaskCardProps {
  task: Task;
  onCardClick: (inputTask: Task) => void;
}

export const TaskCard = ({ task, onCardClick }: TaskCardProps) => {
  const t = useTranslations();
  const theme = useTheme();
  return (
    <WcStack id={"TaskCard" + task.taskID}>
      <WcCard
        onClick={() => onCardClick(task)}
        sx={{
          minWidth: 275,
          cursor: "pointer",
          padding: 0,
          backgroundColor: theme.appColors.surfaceBright,
        }}
      >
        <WcCardContent>
          <WcStack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <WcStack direction={"row"} spacing={4} alignItems={"center"}>
              <WcIcon>
                <PiCalendarDots color={theme.appColors.tertiary} />
              </WcIcon>
              <WcTypography variant="body1">
                {dayjs(task.dueDate).format("DD/MM/YYYY")}
              </WcTypography>
            </WcStack>

            <WcChip label={t(`value.${task.priority}`)}></WcChip>
          </WcStack>
          <WcTypography variant="h6">{task.summary}</WcTypography>
          <WcChip
            avatar={
              <WcAvatar sx={{ color: theme.appColors.secondary }}></WcAvatar>
            }
            label={task.assignedToName}
            sx={{ backgroundColor: `${theme.appColors.secondaryContainer}2A` }}
          ></WcChip>
        </WcCardContent>
      </WcCard>
    </WcStack>
  );
};

export default TaskCard;
